import { useOrganization } from "@clerk/clerk-react";

const INTERNAL_ORG_NAME = "Onsemble";

/**
 * Hook to check if the current user has internal access
 * (belongs to the internal organization)
 */
export function useInternalAccess() {
  const { organization, isLoaded } = useOrganization();

  const isInternal = isLoaded && organization?.name === INTERNAL_ORG_NAME;

  return {
    isInternal,
    isLoaded,
  };
}
